'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var GlobalStyleTag = require('@narvar/nth-bit-global-style-tag');
var DocumentBody = require('@narvar/nth-bit-document-body');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var CsrSignInWizard = require('../CsrSignInWizard/CsrSignInWizard.js');
var index$1 = require('../PagedReturnWizard/index.js');
var index = require('../ProgressiveReturnWizard/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var GlobalStyleTag__default = /*#__PURE__*/_interopDefaultLegacy(GlobalStyleTag);
var DocumentBody__default = /*#__PURE__*/_interopDefaultLegacy(DocumentBody);

const WizardFlow = props => {
  const {
    isCsrSignIn = false,
    progressive = false,
    routerType = 'Hash'
  } = props;
  if (isCsrSignIn) {
    return /*#__PURE__*/React__default["default"].createElement(CsrSignInWizard["default"], null);
  }
  if (progressive) {
    return /*#__PURE__*/React__default["default"].createElement(index["default"], null);
  }
  return /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    routerType: routerType
  });
};
const ReturnWizard = props => {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(GlobalStyleTag__default["default"], null), /*#__PURE__*/React__default["default"].createElement(DocumentBody__default["default"], null), /*#__PURE__*/React__default["default"].createElement(nthHookContextAnalytics.WebVitals, null), /*#__PURE__*/React__default["default"].createElement(WizardFlow, props));
};

exports["default"] = ReturnWizard;
